module.exports = __webpack_public_path__ + "img/microsoft_logo.319d9b9a.svg";